import React, { FC } from 'react';
import NumberFormat from 'react-number-format';

interface FormatAccountNumber {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { value: string } }) => void;
}

const FormatAccountNumber: FC<FormatAccountNumber> = props => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      allowNegative={false}
      allowLeadingZeros={false}
      thousandSeparator={false}
      decimalSeparator='.'
      decimalScale={2}
      fixedDecimalScale
      isNumericString
    />
  );
};

export default FormatAccountNumber;
